import _ from 'lodash';
import { useEffect } from 'react';
import { ROLES } from 'common/constants';
import { useClient } from 'components/ClientProvider';
import { StoreSelect } from 'components/StoreSelect';
import { LandingPageHeader } from 'pages/LandingPage/components';
import { setUserRole } from 'pages/LandingPage/slice';
import { StyledPageContentHeader } from 'pages/LandingPage/styled';
import { useAppDispatch } from 'store/hooks';
import { getUserRole } from 'utils';
import { ApScheduleTable } from './ApScheduleTable';

export const ApSchedulePage = (): React.JSX.Element | null => {
  const userInfo = useClient();
  const dispatch = useAppDispatch();

  const userRole = getUserRole(userInfo?.customClientValues?.permissions);
  useEffect(() => {
    if (userRole !== ROLES.UNAUTHORIZED) dispatch(setUserRole(userRole));
  }, [userRole, dispatch]);

  return !_.isEmpty(userInfo?.headers['x-store-id']) ? (
    <>
      <LandingPageHeader />
      <StyledPageContentHeader>
        <StoreSelect />
      </StyledPageContentHeader>
      <ApScheduleTable />
    </>
  ) : null;
};
